import moment from 'moment';

const googleDateToTimestamp = date => new Date(
  date.substring(0, 4) + '-' +
  date.substring(4, 6) + '-' +
  date.substring(6, 8))
  .getTime();

const getGraphData = ({ x, y }) => {
  x = x || 0;
  y = y || 0;
  const timestamp = googleDateToTimestamp(x);
  const day = timestamp
    ? moment(timestamp).format('D MMM')
    : moment(x, 'YYYYMM').format('D MMM');
  const month = moment(x, 'YYYYMM').format('MMM YY');
  return {
    x,
    y: parseFloat(y),
    day,
    month
  };
};

export default getGraphData;
